import React, { useEffect, useContext } from 'react';
import AnswerButton from '../../Buttons/AnswerButton';
import { useCounter } from '../../../Handler/CounterHandler';
import useDocTitle from '../../../Handler/DocTitleHandler';
import Text from '../../Text';

/**
 * Arthur-Fischer-Erfinderpreis Quick Check App
 *
 * Step C
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const StepBewerber = props => {
  const { setDocTitle } = useDocTitle();
  const { counterCurrent, counterTotal } = useCounter();

  // Changes the doc title
  useEffect(() => {
    setDocTitle(`Schritt ${counterCurrent}/${counterTotal}`);
  }, [counterCurrent]);

  return (<>
    <div className="text text--small text--afp-quickcheck text--counter">{counterCurrent} / {counterTotal}</div>

    <h2 className="headline headline--2">Hinweise</h2>

    <div className="text text--afp-quickcheck">
      <Text path="steps.studentsHinweise.textRect">Mir / Uns ist klar, dass die Auszeichnung einer Erfindung durch die Jury nicht automatisch bedeutet, dass sie rechtlich geschützt ist.</Text>
    </div>

    <div className="container__afp-quickcheck-answers">
      <AnswerButton answer={true}>Ja</AnswerButton>
      <AnswerButton answer={false} nextStep={'result'}>Nein</AnswerButton>
    </div>
  </>);
}

export default StepBewerber;
